import React from 'react'
import { AudioState } from '../types/AudioState'

interface PlayButtonProps {
  soundPath: string
  audioState: AudioState
  onPlay: (soundPath: string) => void
  onStop: (soundPath: string) => void
  disabled?: boolean
  className?: string
}

const PlayButton: React.FC<PlayButtonProps> = ({
  soundPath,
  audioState,
  onPlay,
  onStop,
  disabled = false,
  className = ''
}) => {
  const { isPlaying, isLoading, error } = audioState

  const handleClick = () => {
    if (disabled || isLoading) return

    if (isPlaying) {
      onStop(soundPath)
    } else {
      onPlay(soundPath)
    }
  }

  const getButtonText = () => {
    if (isLoading) return 'Loading...'
    if (error) return 'Error'
    if (isPlaying) return 'Stop'
    return 'Play'
  }

  const getButtonClass = () => {
    const baseClass = 'play-button'
    const stateClass = isPlaying ? 'playing' : isLoading ? 'loading' : error ? 'error' : 'idle'
    return `${baseClass} ${stateClass} ${className}`.trim()
  }

  return (
    <button
      className={getButtonClass()}
      onClick={handleClick}
      disabled={disabled || isLoading}
      aria-label={`${isPlaying ? 'Stop' : 'Play'} sound`}
      title={error || getButtonText()}
    >
      <span className="play-button-text">{getButtonText()}</span>
      {isPlaying && <span className="play-button-indicator" aria-hidden="true">🔊</span>}
      {isLoading && <span className="play-button-spinner" aria-hidden="true">⏳</span>}
      {error && <span className="play-button-error" aria-hidden="true">⚠️</span>}
    </button>
  )
}

export default PlayButton
